import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { FullSizeLoader } from "@/design-system/FullSizeLoader";
import { useEventQueries } from "@/queries/events/queryOptions";

import { EventDetailsContent } from "./EventDetailsContent";

export function EventDetailsPage(): React.ReactNode {
  const { id: eventId } = useParams<{ id: string }>();

  const eventQueries = useEventQueries();
  const {
    data: eventDetails,
    isPending: isEventDetailsPending,
    error: errorEventDetails,
  } = useQuery({
    ...eventQueries.details({
      eventId: eventId!,
      query: { includeAllParticipants: true },
    }),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
  const isPageLoading = isEventDetailsPending;

  if (errorEventDetails) {
    return <ErrorPage error={errorEventDetails} />;
  }

  if (eventDetails == null || isPageLoading) {
    return <FullSizeLoader withPadding />;
  }

  return <EventDetailsContent eventDetails={eventDetails} />;
}
